import React, { useState, useContext } from "react";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Drawer from "../drawer/Drawer";
import { NavLink, useLocation } from "react-router-dom";
import UserContext from "../../context/UserContext";
function Navbar({ onLogout }) {
  const [state, setState] = useState(false);
  const { pathname } = useLocation();
  const { isLogged } = useContext(UserContext);

  const toggle = () => {
    setState((prev) => !prev);
  };

  return (
    <>
      {pathname !== "/join/verify" && (
        <>
          <div className="navbar bg-custom-blue justify-between fixed z-997">
            <div className="flex flex-col w-52 h-16">
              <img src="/images/logo.png" alt="ss" />
              <img src="/images/sologan.png" alt="ss" />
            </div>

            <div className={`flex-none ${isLogged ? "gap-5" : "gap-1"}`}>
              {isLogged ? (
                <>
                  {pathname === "/user/profile" ? (
                    <NavLink to="/">
                      <i class="fa-solid fa-house text-4xl text-gray-800 hover:text-gray-700"></i>
                    </NavLink>
                  ) : (
                    <NavLink to="/user/profile">
                      <i class="fa-solid fa-circle-user text-4xl text-gray-800 hover:text-gray-700 "></i>
                    </NavLink>
                  )}
                </>
              ) : (
                <div className="sm:text-lg md:text-lg lg:text-xl xl:text-2xl gap-2 flex dark:text-gray-200 items-center h-full">
                  <NavLink
                    to="/join/signin"
                    className={({ isActive }) =>
                      isActive ? "dark:text-black text-white" : ""
                    }
                  >
                    Signin
                  </NavLink>
                  |
                  <NavLink
                    to="/join/signup"
                    className={({ isActive }) =>
                      isActive ? "dark:text-black text-white" : ""
                    }
                  >
                    Signup
                  </NavLink>
                </div>
              )}
              <button className="btn btn-square btn-ghost" onClick={toggle}>
                <FontAwesomeIcon
                  icon={faBars}
                  className="h-10 w-10"
                ></FontAwesomeIcon>
              </button>
            </div>
          </div>
          <Drawer isOpen={state} onClose={toggle} logout={onLogout} />
        </>
      )}
    </>
  );
}

export default Navbar;
